module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921085649_T.15133baa.jpg";